module.exports = __webpack_public_path__ + "static/media/service-1.04e6ab17.jpg";